module.exports = __webpack_public_path__ + "img/item14.cc100283.png";